
import { getMetricsApiPrefix } from '../../config/EnvData';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import * as FaIcons from "react-icons/fa";
import React, { useState,useEffect,useRef } from "react";
import axios from 'axios';
import {useParams } from 'react-router-dom';
import Plot from 'react-plotly.js';
import styled from "styled-components";
import Slider from '@mui/material/Slider';
import AirportCarousel from '../../components/AirportCarousel';
import {roundToNthNearestMinute} from "../../utils/funcs.js"
import {PlotSectionDiv,EpochDataBlock} from '../../components/DisplayComponents';
import {PlotLoadingOverlay} from '../../components/PlotLoadingOverlay';

const DEG_TO_NM   = 60.0405
const NM_TO_DEG   = 1/DEG_TO_NM



// const OverlaychartPlotDivStyle = styled.div`
  // display:block;
  // flex:none;
  // justify-content: center;
  // align-items: center;
// `;

// const DetailedSummaryOverlayDiv = ()=>{
        // return(
            // <div style={{position:"fixed",zIndex:15}} >
            // <DetailedSummaryOverlayDivStyle>
                // <OverlaychartPlotDivStyle id="overlayPlot" onClick={handleOverlayClick}>
                // <Plot  data={[{
                    // x: encroachmentData.epochString,
                    // y: encroachmentData.encrDur.Total,
                    // type: 'scatter',
                    // mode: 'lines+markers',
                    // marker: {color: 'red'},
                  // },
                // ]}
                // id="chartPlotDiv"
                // layout={ {title: 'Detailed Summary',width:600,height:400} }
              // />
              // </OverlaychartPlotDivStyle>
            // </DetailedSummaryOverlayDivStyle>
            // </div>
            // );
    // };

const Layout = styled.div`
    display:flex;
    flex:1 1;
    width:100vh;
    justify-content:flex-start;
    flex-wrap:wrap;
    gap: 10px 10px;
    max-height: calc(100vh - 150px);
`;

const TitleDiv = styled.div`
    min-width:85vw;
`;
const colorPalette = ['#2E91E5','#E15F99','#1CA71C','#FB0D0D','#DA16FF','#222A2A','#B68100','#750D86','#EB663B','#511CFB',
					'#FB0D0D','#DA16FF','#222A2A']
const zoomPlusEvent = new KeyboardEvent('keydown', {
  key: '+',           // The key value ('+' for plus)
  code: 'Equal',      // The physical key code (often 'Equal' for '+')
  keyCode: 187,       // The keyCode for '=' which also serves as '+'
  which: 187,         // The which value, same as keyCode
  ctrlKey: true,      // Indicates that Ctrl is pressed
  shiftKey: true,     // Shift is usually needed for the '+' sign
  bubbles: true,      // If the event should bubble up through the DOM
  cancelable: true    // If the event is cancelable
});

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

const zoomMinusEvent = new KeyboardEvent('keydown', {
  key: '-',           // The key value ('+' for plus)
  code: 'Equal',      // The physical key code (often 'Equal' for '+')
  keyCode: 187,       // The keyCode for '=' which also serves as '+'
  which: 187,         // The which value, same as keyCode
  ctrlKey: true,      // Indicates that Ctrl is pressed
  shiftKey: true,     // Shift is usually needed for the '+' sign
  bubbles: true,      // If the event should bubble up through the DOM
  cancelable: true    // If the event is cancelable
});

// <TitleDiv>
            // <h1 style={{marginLeft:'10px'}}>{airport+', '+airportData['city']+' - Mashup Dashboard'}</h1>
        // </TitleDiv>

const homePlotlyIcon = {
            width: 928.6,
            height: 1000,
            path: 'm786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z',
            transform: 'matrix(1 0 0 -1 0 850)'
        }

const sliderMarks = [
  {
    value: 0,
    label: '5 min',
  },
  {
    value: 1,
    label: '1 hour',
  },
  {
    value: 2,
    label: '24 hours',
  },
];
function sortKeyOrder(obj){
  let orderedKeys = Object.keys(obj).sort((a,b) => b.length-a.length)
  let sortedObj = {};
  orderedKeys.forEach(key => {
      sortedObj['Rwy'+key] = obj[key];
  });
  console.log(orderedKeys)
  return(sortedObj);
}
const CenterlineDeviations = ({setTitle,pageTitle,metricLookBackHorizonDays,backendApiPrefix}) => {
    const {airport} = useParams()
    const [isChartLoading,setIsChartLoading] = useState(true)
    const [isMapLoading,setIsMapLoading] = useState(true)
    const [lastUpdatedTime,setLastUpdatedTime] = useState(new Date())
    const [queryIterTime,setQueryIterTime] = useState(new Date())
    const [metricStartTime,setMetricStartTime] = useState(new Date(new Date().getTime() - metricLookBackHorizonDays* 24 * 60 * 60 * 1000))

        
    useEffect(() => {
        setTitle(pageTitle=>'Centerline Deviations - '+airport)
    },[airport]);
    // {

    //     name: 'color toggler',
    
    //     icon: icon1,
    
    //     click: function(gd) {
    
    //         var newColor = colors[Math.floor(3 * Math.random())]
    
    //         Plotly.restyle(gd, 'line.color', newColor)
    
    //     }},
    const [airportData, setAirportData] = useState({'location':[],'city':''}); 
    
    const [selectedEpoch,setSelectedEpoch] = useState('')
    const [selectedRwyArrivals,setSelectedRwyArrivals] = useState({})
    const [selectedMeanCenterlineDeviation,setSelectedMeanCenterlineDeviation] = useState({})
    const [selectedMeanVerticalDeviation,setSelectedMeanVerticalDeviation] = useState({})

    const [latestEpochFlag,setLatestEpochFlag] = useState(true)
    const [epochString,setEpochString] = useState([])
    const [meanCenterlineDeviation,setMeanCenterlineDeviation] = useState({mean:[],L:[],H:[]})
    const [meanVerticalDeviation,setMeanVerticalDeviation] = useState({mean:[],L:[],H:[]})
    const [maxVerticalDeviation,setMaxVerticalDeviation] = useState({mean:[],L:[],H:[]})
    const [allCenterlineDeviationStats,setAllCenterlineDeviationStats] = useState([])
    const [allVerticalDeviationStats,setAllVerticalDeviationStats] = useState([])

    
    const [rwyArrivals,setRwyArrivals] = useState([])
    const [highlightYMarker,setHighlightYMarker] = useState({'index':1,'index2':1})
    const [plotMapLayout, setPlotMapLayout] = useState({
        mapbox: 
        { 
            style: "light", 
            center:{lat:null,lon:null},
            bounds:{'north':null,
                     'east':null,
                    'south':null,
                     'west':null},
            zoom:7,
            accesstoken:"pk.eyJ1IjoidmFydW5zdWRhcnNhbmFuIiwiYSI6ImNscmpiazJ0cDAxb2IyaXFiaWQxY2hobHgifQ.oFJXYhV7inwFB3TeBwa86g",
            domain:{'x':[0.01,1],'y':[0.01,0.99]}
        },
        margin:{l:10,t:10,r:12,b:10},
        xaxis:{showline:true, linewidth:10, linecolor:'black', mirror:true},
        yaxis:{showline:true, linewidth:10, linecolor:'black', mirror:true},
        showlegend:false,plot_bgcolor:'rgba(220,232,247,0.4)'
        },
        );

    const [plotChartLayout, setPlotChartLayout] = useState({grid:{rows:3,columns:1,ygap:0.2},
            xaxis:{anchor:('y','y2'),
                zeroline:false,
                range:[epochString[0],epochString[epochString.length-1]],
                rangeselector:{
                        buttons:[{count:1,label:'1hr',step:'hour',stepmode:'backward'},
                            {count:12,label:'12hrs',step:'hour',stepmode:'backward'},
                            {count:1,label:'1d',step:'day',stepmode:'backward'},
                            {step:'all'}]},
                type:'date',  		
                showticklabels:true,
                autorange:true},
        yaxis:{anchor:'x',title:'Mean Centerline<br>Deviation [ft]',zeroline:false,domain:[0.73,1],range:[],showticklabels:true,autorange:false},
        legend:{x:0,xanchor:'left',y:1.02,bgcolor:'rgba(0,0,0,0)',orientation:'h'},
        //xaxis2:{showticklabels:true},
        xaxis2:{zeroline:false,showticklabels:true,range:[epochString[0],
            epochString[epochString.length-1]]},
        yaxis2:{title:'Mean Deviation<br>Below Min. Altitude [ft]',zeroline:false,domain:[0.45,0.72],range:[],showticklabels:true,autorange:false},
        xaxis3:{anchor:'y3',zeroline:false,domain:[0.0,1]},
        yaxis3:{title:{text:'Arrival Counts',standoff:12},anchor:'x3',zeroline:false,domain:[0.0,0.34]},
    annotations:[],
    margin:{t:54,r:10,b:60},
    height:640,
    hovermode:'x unified',
    plot_bgcolor:'rgba(220,232,247,0.4)'});
    
    const [plotHistoricDistLayout, setPlotHistoricDistLayout] = useState({grid:{rows:2,columns:1,ygap:1},
                              zeroline:false,
                              range:[epochString[0],epochString[epochString.length-1]],
                              xaxis:{anchor:'y',title:'Centerline Deviation [ft]',zeroline:false},
                              xaxis2:{anchor:'y2',title:'Vertical Deviation [ft]<br>(Only non-zero values)',zeroline:false},
                              yaxis:{anchor:'x',zeroline:false,domain:[0.6,1],range:[0,0.3]},
                              yaxis2:{anchor:'x2',zeroline:false,domain:[0.1,0.45],range:[0,0.45]},
                              margin:{t:54,b:20},
                              height:600,
                              title:'Historic Distributions',
                              hovermode:'x unified',plot_bgcolor:'rgba(220,232,247,0.4)'})
    
    const [plotConfig,setPlotConfig] = useState({modeBarButtonsToRemove:['toImage','zoom2d',
        'toggleSpikelines','select2d',
        'zoomIn2d','zoomOut2d','lasso2d',
        'pan2d','autoScale2d', 'resetScale2d','hoverClosestCartesian',
        'hoverCompareCartesian','zoom3d','pan3d', 'resetCameraDefault3d',
        'resetCameraLastSave3d', 'hoverClosest3d', 'orbitRotation', 
        'tableRotation', 'zoomInGeo', 'zoomOutGeo', 'resetGeo', 
        'hoverClosestGeo', 'toImage', 'sendDataToCloud', 'hoverClosestGl2d',
        'hoverClosestPie', 'toggleHover', 'resetViews', 'toggleSpikelines', 'resetViewMapbox'],
         displaylogo:false,responsive:true})

    
    
    const [leftDivHeight, setLeftDivHeight] = useState(null);
    const [leftDivWidth, setLeftDivWidth] = useState(null);
    
    const [rightDivHeight, setRightDivHeight] = useState(null);
    const [rightDivWidth, setRightDivWidth] = useState(null);
    
    const [revKey, setRevKey] = useState(0);
    
    useEffect(() => {
      const interval = setInterval(() => {
        setLastUpdatedTime(new Date())
        getLatestMetricData()
      }, 10000);
      return () => clearInterval(interval);
    }, [latestEpochFlag,epochString,airportData]);


    useEffect(()=>{
      var updateYHighlightMarker = {'index':1.2*Math.max(...meanCenterlineDeviation.mean),
                                    'index2':1.2*Math.max(...meanVerticalDeviation.mean)}
      setHighlightYMarker(updateYHighlightMarker)
  },[selectedEpoch,meanCenterlineDeviation,meanVerticalDeviation])

    useEffect(() =>{
      setTimeout(()=>{
      setPlotChartLayout({...plotChartLayout,
                          width:0.98*leftDivWidth
                        });
      
      setPlotHistoricDistLayout({...plotHistoricDistLayout,
                       width:0.98*rightDivWidth,
                       });
                       
      },20)
    },[leftDivWidth,rightDivWidth]);
    
    function resetMetricStates(){
      setQueryIterTime(new Date())
      setMetricStartTime(new Date(new Date().getTime() - metricLookBackHorizonDays* 24 * 60 * 60 * 1000))
      setMeanCenterlineDeviation({mean:[],L:[],H:[]})
      setMeanVerticalDeviation({mean:[],L:[],H:[]})
      setMaxVerticalDeviation({mean:[],L:[],H:[]})
      setRwyArrivals([])
    };
    useEffect(() => {
        // resetMetricStates()
        axios.post(backendApiPrefix+'/api/get-airport-data/',{airport:airport})
            .then(response => {
                var jsonData = response.data.message
                console.log(jsonData)
                setAirportData(jsonData)
             })
            .catch(error => {
                console.log(error);
            });
        var centerlineDevSTats_api = getMetricsApiPrefix() + 'centerline-deviations/get-stats?airport='+
            airport
        axios.get(centerlineDevSTats_api)
            .then(response => {
              var jsonData = response.data
              setAllCenterlineDeviationStats(jsonData.allMeanDeviationStats)
              var vStats = jsonData.allMeanVerticalDeviationStats.filter(value => (value | 0) !== 0)
              setAllVerticalDeviationStats(vStats)
              setIsMapLoading(false)
            })
            .catch(error => {
              console.log(error)
              setIsMapLoading(false)
            })
            
    },[airport]);
    
        
    useEffect(() => {
      const QUERY_CHUNK_HOURS = 4;
        if(queryIterTime.getTime() >= metricStartTime.getTime()){
            var queryEndTime = queryIterTime
            var shiftedQueryIterTime = new Date(queryIterTime.getTime() - QUERY_CHUNK_HOURS* 60*60*1000)
            var queryEndTimeComps = queryEndTime.toUTCString().split(/-| |:/)
            var queryEndTimeForAPIQuery = queryEndTimeComps[3]+queryEndTimeComps[2]+queryEndTimeComps[1]+queryEndTimeComps[4]+queryEndTimeComps[5]

            var queryStartTimeComps = shiftedQueryIterTime.toUTCString().split(/-| |:/)
            var queryStartTimeForAPIQuery = queryStartTimeComps[3]+queryStartTimeComps[2]+queryStartTimeComps[1]+queryStartTimeComps[4]+queryStartTimeComps[5]
        axios.post(backendApiPrefix+'/api/get-centerline-deviations-data/',{airport:airport,from:queryStartTimeForAPIQuery,to:queryEndTimeForAPIQuery})
          .then(response => {
            var jsonData = response.data.message
            setQueryIterTime(shiftedQueryIterTime)
            setEpochString([...jsonData.epochString,...epochString])
            if(latestEpochFlag&&selectedEpoch===''){
              if(epochString.length > 0){
                setSelectedEpoch(epochString[epochString.length-1])
                setSelectedRwyArrivals(sortKeyOrder(rwyArrivals[rwyArrivals.length-1]))
                setSelectedMeanCenterlineDeviation({mean:meanCenterlineDeviation.mean[meanCenterlineDeviation.mean.length-1],
                                                       L:meanCenterlineDeviation.H[meanCenterlineDeviation.H.length-1],
                                                       H:meanCenterlineDeviation.L[meanCenterlineDeviation.L.length-1]})
                setSelectedMeanVerticalDeviation({mean:meanVerticalDeviation.mean[meanVerticalDeviation.mean.length-1],
                                                        L:meanVerticalDeviation.H[meanVerticalDeviation.H.length-1],
                                                        H:meanVerticalDeviation.L[meanVerticalDeviation.L.length-1]})
              }else{
                setSelectedEpoch(jsonData.epochString[jsonData.epochString.length-1])
                setSelectedRwyArrivals(sortKeyOrder(jsonData.rwyArrivals.map((val)=>JSON.parse(val))[jsonData.rwyArrivals.length-1]))

                setSelectedMeanCenterlineDeviation({mean:jsonData.meanCenterlineDeviation_mean[jsonData.meanCenterlineDeviation_mean.length-1],
                                                       L:jsonData.meanCenterlineDeviation_L[jsonData.meanCenterlineDeviation_L.length-1],
                                                       H:jsonData.meanCenterlineDeviation_H[jsonData.meanCenterlineDeviation_H.length-1]})
                setSelectedMeanVerticalDeviation({mean:jsonData.meanVerticalDeviation_mean[jsonData.meanVerticalDeviation_mean.length-1],
                                                     L:jsonData.meanVerticalDeviation_L[jsonData.meanVerticalDeviation_L.length-1],
                                                     H:jsonData.meanVerticalDeviation_H[jsonData.meanVerticalDeviation_H.length-1]})
              }
            }
            
            
            

            setMeanCenterlineDeviation({...meanCenterlineDeviation,
                                       mean:[...jsonData.meanCenterlineDeviation_mean,...meanCenterlineDeviation.mean],
                                          L:[...jsonData.meanCenterlineDeviation_L,...meanCenterlineDeviation.L],
                                          H:[...jsonData.meanCenterlineDeviation_H,...meanCenterlineDeviation.H]})
            
            setMeanVerticalDeviation({...meanVerticalDeviation,
                                      mean:[...jsonData.meanVerticalDeviation_mean,...meanVerticalDeviation.mean],
                                         L:[...jsonData.meanVerticalDeviation_L,...meanVerticalDeviation.L],
                                         H:[...jsonData.meanVerticalDeviation_H,...meanVerticalDeviation.H]})
            setMaxVerticalDeviation({...maxVerticalDeviation,
                                      mean:[...jsonData.maxVerticalDeviation_mean,...maxVerticalDeviation.mean]})

            setRwyArrivals([...jsonData.rwyArrivals.map((val)=>JSON.parse(val)),...rwyArrivals])
            
            setPlotChartLayout({...plotChartLayout,
                yaxis:{...plotChartLayout.yaxis,
                         range:[0,1.2*Math.max(...[...jsonData.meanCenterlineDeviation_mean,...meanCenterlineDeviation.mean])]
                },
                yaxis2:{...plotChartLayout.yaxis2,
                            range:[0,1.2*Math.max(...[...jsonData.meanVerticalDeviation_mean,...meanVerticalDeviation.mean])]
                }})
            setIsChartLoading(false)
    })
          .catch(error => {
            console.log(error);
            setIsChartLoading(false)
          });
    }

  },[airport,queryIterTime])

    function getLatestMetricData(){
      var centerlineDeviation_api_latest = getMetricsApiPrefix() + 'centerline-deviations?airport='+
                                            airport+'&duration=latest' 
      axios.get(centerlineDeviation_api_latest)
      .then(response => {
        var jsonData = response.data
        setEpochString([...epochString,jsonData.epochString])
        if(latestEpochFlag){
            setSelectedEpoch(jsonData.epochString)
            setSelectedRwyArrivals(sortKeyOrder(JSON.parse(jsonData.rwyArrivals)))
            setSelectedMeanCenterlineDeviation({mean:jsonData.meanCenterlineDeviation_mean,
                                                   L:jsonData.meanCenterlineDeviation_L,
                                                   H:jsonData.meanCenterlineDeviation_H})
            setSelectedMeanVerticalDeviation({mean:jsonData.meanVerticalDeviation_mean,
                                                    L:jsonData.meanVerticalDeviation_L,
                                                    H:jsonData.meanVerticalDeviation_H})
        }
        setMeanCenterlineDeviation({...meanCenterlineDeviation,
                                    mean:[...meanCenterlineDeviation.mean,jsonData.meanCenterlineDeviation_mean],
                                    L:[...meanCenterlineDeviation.L,jsonData.meanCenterlineDeviation_L],
                                    H:[...meanCenterlineDeviation.H,jsonData.meanCenterlineDeviation_H]})
        setMeanVerticalDeviation({...meanVerticalDeviation,
                                    mean:[...meanVerticalDeviation.mean,jsonData.meanVerticalDeviation_mean],
                                    L:[...meanVerticalDeviation.L,jsonData.meanVerticalDeviation_L],
                                    H:[...meanVerticalDeviation.H,jsonData.meanVerticalDeviation_H]})
        setMaxVerticalDeviation({...maxVerticalDeviation,
                                   mean:[...maxVerticalDeviation.mean,jsonData.maxVerticalDeviation_mean]})
        setRwyArrivals([...rwyArrivals,JSON.parse(jsonData.rwyArrivals)])
        // setPlotChartLayout({...plotChartLayout,
        //     yaxis:{...plotChartLayout.yaxis,
        //              range:[0,Math.max(...jsonData.meanCenterlineDeviation_mean)]
        //     },
        //     yaxis2:{...plotChartLayout.yaxis2,
        //                 range:[0,Math.max(...jsonData.meanVerticalDeviation_mean)]
        //     }})
      })         
      .catch(error => {
        console.log(error);
      });
    };

    
    const mounted = useRef();
    useEffect(() => {
       if(mounted.current){
           // Component mounted
           console.log("Updated")
       } else {
            console.log("Mounted")
            mounted.current = true
            
       }
    });
    // const chartDiv = useCallback(node => {
        // if (node !== null) {
          // setLeftDivHeight(node.getBoundingClientRect().height);
          // setLeftDivWidth(node.getBoundingClientRect().width);
          // console.log("HEIGHT",height)
          // console.log("HEIGHT",width)
        // }
        // }, []);
    const [isRefreshing, setIsRefreshing] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // This will be called on both refresh and page close
      setIsRefreshing(true);
      setRevKey(prevVal => prevVal +1)
      // The following is necessary for older browsers
      event.preventDefault();
      event.returnValue = '';
    };

    
    window.addEventListener('load', handleBeforeUnload);

    return () => {
      window.removeEventListener('load', handleBeforeUnload);
    };
  });

  useEffect(() => {
        const resizeObserver = new ResizeObserver((event) => {
            // Depending on the layout, you may need to swap inlineSize with blockSize
            // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize
            setLeftDivWidth(event[0].contentBoxSize[0].inlineSize);
            setLeftDivHeight(event[0].contentBoxSize[0].inlineSize);
        });

        resizeObserver.observe(document.getElementById("plotlyChartDiv"));
        
        
    });
    
    useEffect(() => {
        const resizeObserver = new ResizeObserver((event) => {
            // Depending on the layout, you may need to swap inlineSize with blockSize
            // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize
            setRightDivWidth(event[0].contentBoxSize[0].inlineSize);
            setRightDivHeight(event[0].contentBoxSize[0].inlineSize);
        });

        resizeObserver.observe(document.getElementById("plotlyHistoricDistributionsDiv"));
    });
    const [menuOption, setMenuOption] = React.useState(1);

    const handleChange = (event: SelectChangeEvent) => {
        setMenuOption(String(event.target.value));
      };
    
    // const fetchAndUpdateConflictTracks=(epochVal)=>{
    //     var epochStringComps = epochVal.split(/-| |:/) 
    //     var epochFormatForAPIQuery = monthNames[parseInt(epochStringComps[1])-1]+
    //                             epochStringComps[2]+epochStringComps[3]+epochStringComps[4]
        
    //     console.log("Epoch for query")
    //     console.log(epochFormatForAPIQuery)
    //     var metroplexConflictData_api = 'https://chapfk2u97.execute-api.us-east-2.amazonaws.com/test/metroplex-buffer-encroachments/conflict-data?'+
    //                                             'metroplex='+airportData.metroplex+'&epoch='+epochFormatForAPIQuery

    //     Promise.all([
    //         fetch(metroplexConflictData_api)
    //     ]).then(function (responses) {
    //         // Get a JSON object from each of the responses
    //         return Promise.all(responses.map(function (response) {
    //             return response.json();
    //         }));
    //     }).then(function (json_data_array) {
    //         updateConflictTracksOnMap(json_data_array[0])
    //     }).catch(error => {
    //         console.log(error);
    //     });
    // }
    const handleLatestEpochButton = () =>{
        setLatestEpochFlag(true)
        setSelectedEpoch(epochString[epochString.length-1])
        setSelectedRwyArrivals(sortKeyOrder(rwyArrivals[rwyArrivals.length-1]))
        setSelectedMeanCenterlineDeviation({mean:meanCenterlineDeviation.mean[meanCenterlineDeviation.mean.length-1],
                                              L:meanCenterlineDeviation.L[meanCenterlineDeviation.L.length-1],
                                              H:meanCenterlineDeviation.H[meanCenterlineDeviation.H.length-1]})
        setSelectedMeanVerticalDeviation({mean:meanVerticalDeviation.mean[meanVerticalDeviation.mean.length-1],
                                              L:meanVerticalDeviation.L[meanVerticalDeviation.L.length-1],
                                              H:meanVerticalDeviation.H[meanVerticalDeviation.H.length-1]})
        setPlotChartLayout({...plotChartLayout,
                               yaxis:{...plotChartLayout.yaxis,
                                        range:[0,1.2*Math.max(...meanCenterlineDeviation.mean)]
                               },
                               yaxis2:{...plotChartLayout.yaxis2,
                                range:[0,1.2*Math.max(...meanVerticalDeviation.mean)]
                       }})
        // fetchAndUpdateConflictTracks(epochString[epochString.length-1])

    };
    
    const handleClickOnChart=(data)=>{
        console.log(data)
        var point = data.points[0]
        setLatestEpochFlag(false)
        if(!(new Date(point.x) instanceof Date && !isNaN(new Date(point.x).valueOf()))){
            return;
        }
        console.log(point)
        console.log(point.pointIndex)
        console.log(epochString[point.pointIndex])
        setSelectedEpoch(epochString[point.pointIndex])
        setSelectedRwyArrivals(sortKeyOrder(rwyArrivals[point.pointIndex]))
        setSelectedMeanCenterlineDeviation({mean:meanCenterlineDeviation.mean[point.pointIndex],
                                              L:meanCenterlineDeviation.L[point.pointIndex],
                                              H:meanCenterlineDeviation.H[point.pointIndex]})
        setSelectedMeanVerticalDeviation({mean:meanVerticalDeviation.mean[point.pointIndex],
                                             L:meanVerticalDeviation.L[point.pointIndex],
                                             H:meanVerticalDeviation.H[point.pointIndex]})

        setPlotChartLayout({...plotChartLayout,
                               yaxis:{...plotChartLayout.yaxis,
                                        range:[0,1.2*Math.max(...meanCenterlineDeviation.mean)]
                               },
                               yaxis2:{...plotChartLayout.yaxis2,
                                range:[0,1.2*Math.max(...meanVerticalDeviation.mean)]
                       },
        })

        // fetchAndUpdateConflictTracks(epochString[point.pointIndex])
    };
    var highlightMarkerTraces = []
    for(var axNum of ['','2']){
        highlightMarkerTraces.push({ x:[selectedEpoch,selectedEpoch],
          y:[0,highlightYMarker['index'+axNum]],
          type:'scatter',
          xaxis:'x',yaxis:'y'+axNum,
          mode:'lines',
          showlegend:false,
          hoverinfo:'skip',
          line:{color:'black',dash:'dashdot'}})
    }

    var allCenterlineDeviationStats_trace = {x:allCenterlineDeviationStats,
                                  type:'histogram',
                                  xaxis:'x',
                                  yaxis:'y',
                                  opacity:0.4,
                                  histnorm:'probability',
                                  marker:{color:'blue'},
                                  name:'Historic Centerline Deviations',
                                  hovertemplate:'Mean Centerline Deviation<br>Historic Distribution<extra></extra>',
                                  showlegend:false}
    var allVerticalDeviationStats_trace = {x:allVerticalDeviationStats,
                                  type:'histogram',
                                  xaxis:'x2',
                                  yaxis:'y2',
                                  opacity:0.4,
                                  histnorm:'probability',
                                  marker:{color:'blue'},
                                  name:'Historic Vertical Deviations',
                                  hovertemplate:'Mean Vertical Deviation<br>Historic Distribution<extra></extra>',
                                  showlegend:false}

    var yMax = 0.3;
    var y2Max = 0.45;

    var selectedCenterlineDeviationMean_trace = {x:[selectedMeanCenterlineDeviation.mean,selectedMeanCenterlineDeviation.mean],
                                         y:[0,yMax],
                                         type:'scatter',
                                         xaxis:'x',
                                         yaxis:'y',
                                         mode:'lines',
                                         hovertemplate:'Epoch:'+selectedEpoch+
                                             '<br>Mean Deviation: %{x}ft<extra></extra>',
                                         line:{color:'black',dash:'dashdot'},
                                         name:'Selected Epoch',
                                         showlegend:false}
    
    var selectedVerticalDeviationMean_trace = {x:[-1*selectedMeanVerticalDeviation.mean,-1*selectedMeanVerticalDeviation.mean],
                                          y:[0,y2Max],
                                          type:'scatter',
                                          xaxis:'x2',
                                          yaxis:'y2',
                                          mode:'lines',
                                          hovertemplate:'Epoch:'+selectedEpoch+
                                              '<br>Mean Deviation: %{x}ft<extra></extra>',
                                          line:{color:'black',dash:'dashdot'},
                                          name:'Selected Epoch',
                                          showlegend:false}

    var centerlineDeviationStatRegion_trace = {x:[selectedMeanCenterlineDeviation.L,selectedMeanCenterlineDeviation.L,selectedMeanCenterlineDeviation.H,
                                                  selectedMeanCenterlineDeviation.H,selectedMeanCenterlineDeviation.L],
                                               y:[0,yMax,
                                                    yMax,0,0],
                                               type:'scatter',
                                               fill:'tonexty',
                                               xaxis:'x',
                                               yaxis:'y',
                                               mode:'none',
                                               hovertemplate:'Epoch:'+selectedEpoch+
                                                             '<br>Mean Dev.:'+selectedMeanCenterlineDeviation.mean+'ft'+
                                                             '<br>Low Dev.:'+selectedMeanCenterlineDeviation.L+'ft'+
                                                             '<br>High Dev.:'+selectedMeanCenterlineDeviation.H+'ft'+
                                                             '<extra></extra>',
                                              hoveron:'points',fillcolor:'rgba(255,0,0,0.2)',name:'Selected Centerline Deviation',showlegend:false}
    var verticalDeviationStatRegion_trace = {x:[-1*selectedMeanVerticalDeviation.L,-1*selectedMeanVerticalDeviation.L,-1*selectedMeanVerticalDeviation.H,
                                                -1*selectedMeanVerticalDeviation.H,-1*selectedMeanVerticalDeviation.L],
                                             y:[0,y2Max,y2Max,0,0],
                                             type:'scatter',
                                             fill:'tonexty',
                                             xaxis:'x2',
                                             yaxis:'y2',
                                             mode:'none',
                                             hovertemplate:'Epoch:'+selectedEpoch+
                                                           '<br>Mean Dev.:'+selectedMeanVerticalDeviation.mean+'ft'+
                                                           '<br>Low Dev.:'+selectedMeanVerticalDeviation.L+'ft'+
                                                           '<br>High Dev.:'+selectedMeanVerticalDeviation.H+'ft'+
                                                           '<extra></extra>',
                                            hoveron:'points',fillcolor:'rgba(255,0,0,0.2)',name:'Selected Vertical Deviation',showlegend:false}
    // var allDeviationStat_trace = {x:allMeanDeviationStats,
    //       type:'histogram',
    //       xaxis:'x7',
    //       yaxis:'y7',
    //       opacity:0.4,
    //       histnorm:'probability',
    //       marker:{color:'blue'},
    //       name:'Historic',
    //       hovertemplate:'Mean Centerline Deviation<br>Historic Distribution<extra></extra>',
    //       showlegend:false}

    return (
        <Layout>
        <PlotSectionDiv id="chartPlotDiv" flexRatio={5}>
            <PlotLoadingOverlay show={isChartLoading}/>
            <EpochDataBlock selectedEpoch={selectedEpoch} handleLatestEpochButton={handleLatestEpochButton} lastUpdatedTime={lastUpdatedTime}/>
            <Plot  data={[{
                    x: epochString,
                    y: meanCenterlineDeviation.mean,
                    type: 'scatter',
                    mode: 'lines',
                    name:'Centerline Deviation',
                    hovertemplate:'%{y} ft<extra>Mean Centerline<br>Deviation</extra>',
                    xaxis:'x',
                    yaxis:'y',
                    showlegend:false
                  },
                  { x:epochString,
                    y:meanVerticalDeviation.mean,
                    type:'scatter',
                    name:'Vertical Deviation',
                    hovertemplate:'%{y} ft<extra>Mean Vertical<br>Deviation</extra>',
                    xaxis:'x',
                    yaxis:'y2',
                    showlegend:false},
                  { x:Object.keys(selectedRwyArrivals).map(String),
                    y:Object.values(selectedRwyArrivals),
                    type:'bar',
                    xaxis:'x3',
                    yaxis:'y3',
                    width:0.6,
                    name:'Arrival Counts',
                    marker:{color:'indianred'},
                    hovertemplate:'%{y}',
                    showlegend:false},
                  ...highlightMarkerTraces
                ]}
                layout= {{...plotChartLayout,
                            xaxis3:{...plotChartLayout.xaxis3,
                                  tickvals:Object.keys(selectedRwyArrivals),
                                  ticktext:Object.keys(selectedRwyArrivals).map(val => val.slice(3))
                            }
                        }}
                config= {plotConfig}
                divId={'plotlyChartDiv'}
                style={{minWidth:'300px',height:'95%',position:'relative'}}
                useResizeHandler={true}
                onClick={handleClickOnChart}
                onDoubleClick={()=>{}}
              />
        </PlotSectionDiv>
        <PlotSectionDiv id="mapPlotDiv" key={revKey} flexRatio={3}>
            <PlotLoadingOverlay show={isMapLoading} label="Loading distributions…"/>
            <Plot data={[allCenterlineDeviationStats_trace,selectedCenterlineDeviationMean_trace,centerlineDeviationStatRegion_trace,
                         allVerticalDeviationStats_trace,selectedVerticalDeviationMean_trace,verticalDeviationStatRegion_trace]}
                  layout= {plotHistoricDistLayout}
                  config= {plotConfig}
                  useResizeHandler={true}
                  divId={'plotlyHistoricDistributionsDiv'}
                  style={{minWidth:'300px',height:'90%',position:'relative',borderWidth:'2px'}}
            />
        </PlotSectionDiv>  
        </Layout>
    );
};

export default CenterlineDeviations


